<template>
  <div class="selectDevice">
    <div style="margin-top: 10px">
      <el-form :inline="true" :model="deviceSelectInfo" label-width="130px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="项目名称" prop="projectId">
              <el-select v-model="deviceSelectInfo.projectId" style="width: 240px" @change="switchProject" :disabled="isType!=='add'">
                <el-option v-for="(item,index) in projectOptions" :key="index" :label="item.projectName" :value="item.projectId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="项目编号" prop="projectId">
              <el-input v-model="deviceSelectInfo.projectId" disabled style="width: 240px;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="并网点" prop="gridId">
              <el-select v-model="deviceSelectInfo.gridId" style="width: 240px" :disabled="isType!=='add'">
                <el-option v-for="(item,index) in gridOptions" :key="index" :label="item.gridName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="设备类型" prop="equipType">
              <el-select v-model="deviceSelectInfo.equipType" style="width: 240px" @change="switchDeviceType" :disabled="isType!=='add'">
                <el-option v-for="(item,index) in deviceTypeOptions" :key="index" :label="item.optionName" :value="item.optionType"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div>
      <el-form :model="deviceSelectInfo">
        <el-card shadow="never">
          <div slot="header">{{"请选择需要配置点表的同类设备"}}</div>
          <div style="max-height: 500px; overflow: auto;" v-loading="loading">
            <el-tree
              :data="deviceTreeData"
              show-checkbox
              node-key="equipId"
              ref="deviceTree"
              :default-checked-keys="defaultChecked"
              :default-expand-all="defaultExpandAll"
              highlight-current
              :props="defaultProps">
            </el-tree>
          </div>
        </el-card>
      </el-form>
    </div>
  </div>
</template>

<script>
  import API from '@/api/parallel';
  import EQUIPMENTCONFIGAPI from '@/api/equipmentConfig';

  export default {
    props: {
      id: {                                 // 父组件列表 id
        type: [String, Number]
      },
      projectId: {
        type: [String, Number]
      },
      isType: {
        type: [String, Number]
      }
    },
    data() {
      return {
        loading: false,

        deviceSelectInfo: {
          projectId: '',
          projectName: '',
          equipType: '',
          equipTypeName: "",
          equipFits: [],
          gridId:''
        },

        projectOptions: [{                  // 项目名称列表（筛选）
          label: '信诚一期',
          value: '111'
        }],
        deviceTypeOptions: [],              // 设备类型列表（筛选）

        deviceTreeData: [],                 // 设备列表树
        defaultProps: {
          children: 'children',
          label(data) {
            return data.equipName + " (" + data.equipDesc + ")"
          }
        },
        defaultChecked: [],                 // 默认勾选节点数组
        defaultExpandAll: false,
        gridOptions:[]
      };
    },
    components: {},
    created() {
      this.getAllProjects();                // 获取项目列表
      this.equipTypeList();                 // 获取设备类型

      // 点击配置进入该页面
      if (this.isType === 'edit') {
        this.equipCheckTreeList();          // 获取设备列表(设备树)
        this.getEquipConfigDetail();        // 获取设备配置详情
      }
    },
    methods: {
      //获取并网点列表
      searchProjectGridList() {
        let params = {
          projectId: this.deviceSelectInfo.projectId,
          pageNum: 1,
          pageSize: 100
        }
        EQUIPMENTCONFIGAPI.searchProjectGridList(params).then(res => {
          if (res.data.code == 200) {
            this.gridOptions = res.data.data.dataList
            this.gridOptions.map(item => {
              item.id = item.id + ''
              return item
            })
          }
        })
      },
      // 获取所有项目
      getAllProjects() {
        API.getAllProjects().then(res => {
          if (res.data.code === 200) {
            this.projectOptions = res.data.data;
          }
        })
      },

      // 获取设备类型
      equipTypeList() {
        EQUIPMENTCONFIGAPI.equipTypeList().then(res => {
          if (res.data.code === 200) {
            this.deviceTypeOptions = res.data.data;
          }
        });
      },

      // 获取设备树
      equipCheckTreeList() {
        this.loading = true;
        let params = {
          projectId: this.deviceSelectInfo.projectId ? this.deviceSelectInfo.projectId : this.projectId,
        };
        if (this.id && this.id > 0) {
          params.infoId = this.id
        }
        EQUIPMENTCONFIGAPI.equipCheckTreeList(params).then(res => {
          if (res.data.code === 200 && !res.data.errors) {
            this.defaultExpandAll = res.data.data.length <= 1;
            // 只展示到三级
            this.deviceTreeData = this.formatTreeData(res.data.data);
          }
          if (res.data.errors) {
            this.$message.error(res.data.errors);
          }
        });
        this.loading = false;
      },

      // 查询设备配置详情
      getEquipConfigDetail() {
        let params = {
          projectId: this.projectId,
        };
        if (this.id && this.id > 0) {
          params.infoId = this.id
        }
        EQUIPMENTCONFIGAPI.getEquipConfigDetail(params).then(res => {
          if (res.data.code === 200 && !res.data.errors) {
            this.deviceSelectInfo.projectId = res.data.data.projectId;
            this.deviceSelectInfo.projectName = res.data.data.projectName;
            this.deviceSelectInfo.equipType = res.data.data.equipType;
            this.deviceSelectInfo.equipTypeName = res.data.data.equipTypeName;
            this.deviceSelectInfo.gridId = res.data.data.gridId+''
            this.searchProjectGridList()
            if (res.data.data.equipFits && res.data.data.equipFits.length > 0) {
              this.defaultChecked = res.data.data.equipFits.map(item => item.equipId);
            }
          }
          if (res.data.errors) {
            this.$message.error(res.data.errors);
          }
        });
      },

      // 设备列表展示到三级
      formatTreeData(deviceList) {
        if (deviceList && deviceList.length > 0) {
          for (const L1Data of deviceList) {
            if (L1Data.childList && L1Data.childList.length > 0) {
              for (const L2Data of L1Data.childList) {
                if (L2Data.childList && L2Data.childList.length > 0) {
                  for (const L3Data of L2Data.childList) {
                    if (L3Data.childList && L3Data.childList.length > 0) {
                      L3Data.childList = [];
                    }
                  }
                }
              }
            }
          }
        }
        return deviceList;
      },

      // 切换项目名称
      switchProject(v) {
        this.deviceSelectInfo.projectId = v;
        this.deviceSelectInfo.gridId = ''
        const foundItem = this.projectOptions.find(item => item.projectId === v);
        if (foundItem) {
          this.deviceSelectInfo.projectName = foundItem.projectName;
        }
        this.equipCheckTreeList();
        this.searchProjectGridList()
      },

      // 切换设备类型
      switchDeviceType(v) {
        this.deviceSelectInfo.equipType = v;
        const foundItem = this.deviceTypeOptions.find(item => item.optionType === v);
        if (foundItem) {
          this.deviceSelectInfo.equipTypeName = foundItem.optionName;
        }
      },

      // 传已选表单信息给父组件 -> 设备绑定页
      commitSelectedFormInfo() {
        const selectFormInfo = {
          projectId: '',
          projectName: '',
          equipType: -1,
          equipTypeName: '',
          equipFitIds: [],          // 已选设备（待绑点设备）
        };

        selectFormInfo.projectId = this.deviceSelectInfo.projectId;
        selectFormInfo.projectName = this.deviceSelectInfo.projectName;
        selectFormInfo.equipType = this.deviceSelectInfo.equipType;
        selectFormInfo.equipTypeName = this.deviceSelectInfo.equipTypeName;
        selectFormInfo.gridId = this.deviceSelectInfo.gridId;

        let checkedNode = this.$refs.deviceTree.getCheckedKeys();
        selectFormInfo.equipFitIds = checkedNode.map((item) => Number(item)).filter(item => !isNaN(item));

        this.$emit('custom-event', selectFormInfo)
      }
    }
  };
</script>

<style lang="scss">
  .selectDevice {}
</style>



// WEBPACK FOOTER //
// src/views/boss/deviceConfiguration/selectDevice.vue